import script from "./InternetConfigNumberTransfer.vue?vue&type=script&setup=true&lang=ts"
export * from "./InternetConfigNumberTransfer.vue?vue&type=script&setup=true&lang=ts"

import "./InternetConfigNumberTransfer.vue?vue&type=style&index=0&id=7c41f082&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c41f082"]])

export default __exports__